import type {PropsWithChildren} from 'react';
import styles from './root.module.css';

type Props = PropsWithChildren;

export function MediaUserOnlyInfoRoot({children}: Props) {
  return <div className={styles.root}>{children}</div>;
}
